/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_Overview_TitleInputs */

const es_walkthrough_admin_overview_title = /** @type {(inputs: Walkthrough_Admin_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de la Empresa`)
};

const en_walkthrough_admin_overview_title = /** @type {(inputs: Walkthrough_Admin_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Overview`)
};

/**
* | output |
* | --- |
* | "Company Overview" |
*
* @param {Walkthrough_Admin_Overview_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_overview_title = /** @type {((inputs?: Walkthrough_Admin_Overview_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_Overview_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_overview_title(inputs)
	return en_walkthrough_admin_overview_title(inputs)
});
export { walkthrough_admin_overview_title as "walkthrough.admin_overview_title" }